import type { FaireProductEntity } from "../../entity_types/product";

export const p_n2f4p5pugb: FaireProductEntity = {
  token: "p_n2f4p5pugb",
  type: "product",
  name: "Blush Watercolor Rainbow Organic Baby Knotted Natural Gown",
  brandToken: "b_4ktjmwa4",
  brandName: "Urban Baby Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/80370e7852f255f5266f2a3a971c5214a1b3d98a2ba61ac30aea7038b83aed56.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/884230766665a78a44db709d3a0b1479d6d8cfc5100c430fef82b7d91ac7ddc8.jpeg",
    "https://cdn.faire.com/fastly/c568f6ea4174ae22f37996713dfdf9c286b1c28e4d41395375d64dba1ae35932.jpeg",
    "https://cdn.faire.com/fastly/901730481f473cd11df5c7a72a92f6f52b6e063aca791d9bb844c8fa91dd0aa5.jpeg",
  ],
  priceDollars: 17.25,
  description:
    "•Size: 0-3 months\n•Printed in-house in Denver, CO.\n•Garment is made from 100% soft organic cotton, single jersey.\n•Features fold-over cuffs and an adjustable tie bottom. \n•No harmful chemicals, pesticides, or artificial dyes.\n•Sustainably sourced and ethically produced.\n•As with any organic, non-bleached cotton some fabric imperfections are normal.\n•Urban Baby Co. logo will be printed on the back neck of garment.",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:22.101Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
